import { combineReducers } from 'redux';

import { Reducer } from '../../../types';
import { stripItems } from '../../../../utility/store';
import { StateListDocuments, DocumentAction } from '../types'
import {
  getDocumentListRequest,
  getDocumentListSuccess,
  getDocumentListFail,
  setDocumentListDirty,
} from '../actions';

type ReducerOf<T extends keyof StateListDocuments> = Reducer<StateListDocuments, DocumentAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getDocumentListRequest.type:
      return state ? stripItems(state) : null;

    case getDocumentListSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getDocumentListRequest.type:
      return true;

    case getDocumentListSuccess.type:
    case getDocumentListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setDocumentListDirty.type:
      return action.payload;

    case getDocumentListSuccess.type:
    case getDocumentListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateListDocuments>({
  data,
  loading,
  dirty,
});
